import React from 'react';
import ButtonHoverRender from '../../../Buttons/ButtonHover/ButtonHoverRender';
import ButtonHoverPrimary from '../../../Buttons/ButtonHover/ButtonHoverPrimary';
import formBlack from '../../../../images/form-black.svg';
import formWhite from '../../../../images/form-white.svg';

const FormsButton = ({ primaryColor, openModal }) => {
  return (
    <ButtonHoverRender
      render={({ onEnter, onLeave, hovering }) => (
        <ButtonHoverPrimary
          onEnter={onEnter}
          onLeave={onLeave}
          hovering={hovering}
          handleClick={openModal}
          className={'display-form-btn'}
          color="#fff"
          backgroundColor={primaryColor}
          aria-label="Open tour form"
          tooltip={{
            text: 'form',
            node: '.display-form-btn',
            position: 'top',
          }}
          tooltipClass={'form-tooltip'}
          position='inherit'
        >
          <img
            className="form-icon"
            src={hovering ? formBlack : formWhite}
            alt=""
            aria-hidden="true"
          />
        </ButtonHoverPrimary>
      )}
    />
  );
};

export default FormsButton;
